import React, { FC } from 'react';
import { PromoBanner } from '@agria/theme/src/components/promoBanner/PromoBanner';
// import { graphql, useStaticQuery } from 'gatsby';
import Stack from '@agria/theme/src/components/stack/Stack';

export interface WhenGetCoverProps {
  onClick?: () => void;
}

export const WhenGetCover: FC<WhenGetCoverProps> = () => null;
